module.exports = __webpack_public_path__ + "img/uv_on.10d37a4b.png";